import { css, keyframes } from "@emotion/react"
import { GlobalToken } from "antd"

export const buttonCss = (theme: GlobalToken) => css`
	&.ant-btn-primary {
		background-color: ${theme?.colorPrimary};
		border-color: ${theme?.colorPrimary};
		&:hover {
			border-color: ${theme?.colorPrimaryHover};
			background-color: ${theme?.colorPrimaryHover};
		}

		&[disabled] {
			background-color: ${theme?.colorBgContainerDisabled};
			border-color: ${theme?.colorBorderSecondary};
			color: ${theme?.colorTextDisabled};
		}
	}

	&.ant-btn-default,
	&.ant-btn-dashed {
		background: none;
		border-color: ${theme?.colorPrimary};
		color: ${theme?.colorPrimary};
		&:hover {
			border-color: ${theme?.colorPrimaryHover};
			color: ${theme?.colorPrimaryTextHover};
			//background-color: ${theme?.colorPrimaryHover};
		}

		&[disabled] {
			background-color: ${theme?.colorBgContainerDisabled};
			border-color: ${theme?.colorBorderSecondary};
			color: ${theme?.colorTextDisabled};
		}
	}

	&.ant-btn-link {
		color: ${theme?.colorPrimary};

		&:hover {
			color: ${theme?.colorPrimaryTextHover} !important;
		}

		&[disabled] {
			color: ${theme?.colorTextDisabled} !important;
		}
	}
	&.pulsing-dot {
		animation: ${pulsingAnimation} 0.7s alternate infinite;
	}
`

const pulsingAnimation = keyframes`
		0%{
			opacity: 1;
		}
		100%{
			opacity: 0.2
		}
`
